'use strict';
import * as $j_app$002etulz$002etuplez$002e$002dComposition from "./app.tulz.tuplez.-Composition.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276() {
}
export { $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276 as $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276 };
$c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276.prototype = new $j_app$002etulz$002etuplez$002e$002dComposition.$h_Lapp_tulz_tuplez_Composition();
$c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276.prototype.constructor = $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276() {
}
export { $h_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276 as $h_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276 };
$h_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276.prototype = $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276.prototype;
$c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276.prototype.decompose__O__T2 = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), c, (void 0));
});
$c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276.prototype.compose__O__O__O = (function(a, b) {
  return a;
});
var $d_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276, "app.tulz.tuplez.Composition_Pri10$$anon$276", ({
  Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276: 1,
  Lapp_tulz_tuplez_Composition: 1
}));
export { $d_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276 as $d_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$276 };
//# sourceMappingURL=app.tulz.tuplez.-Composition_-Pri10$$anon$276.js.map
